module.exports = __webpack_public_path__ + "media/logos/tiktok-logo-white-1eb15dbc.svg";